var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBianjiJuhe(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bianji_juhe_svg__clip0_5325_70430)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.402 2.103a1.5 1.5 0 011.196 0l5.256 2.283a.9.9 0 010 1.651L8.598 8.321a1.5 1.5 0 01-1.196 0L2.146 6.037a.9.9 0 010-1.65m5.256-2.284L2.146 4.386m5.256-2.283L2.146 4.386m5.256-2.283L2.345 4.845l-.2-.459",
    stroke: "#3F465C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42 6.046l-1.474.64c-1.123.487-1.123 2.08 0 2.568l5.257 2.283a2 2 0 001.594 0l5.257-2.283c1.123-.488 1.123-2.08 0-2.568l-1.474-.64-1.255.545 1.92.834.018.007.392.17a.4.4 0 010 .735l-.393.17-.017.008-4.847 2.105a1 1 0 01-.796 0L2.755 8.515l-.017-.008-.393-.17a.4.4 0 010-.734l.393-.17.017-.008 1.92-.834-1.255-.545z",
    fill: "#3F465C"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42 8.804l-1.474.64c-1.123.487-1.123 2.08 0 2.568l5.257 2.283a2 2 0 001.594 0l5.257-2.283c1.123-.488 1.123-2.08 0-2.568l-1.474-.64-1.255.545 1.92.834.018.007.392.171a.4.4 0 010 .734l-.393.17-.017.008-4.847 2.105a1 1 0 01-.796 0l-4.847-2.105-.017-.008-.393-.17a.4.4 0 010-.734l.393-.17.017-.008 1.92-.834-1.255-.545z",
    fill: "#3F465C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bianji_juhe_svg__clip0_5325_70430"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
export default __webpack_public_path__ + "static/bianji_juhe.cc0d7b25.svg";
export { SvgBianjiJuhe as ReactComponent };